<template>
  <div class="live">
    <a href="https://get.adobe.com/cn/flashplayer/" v-if="flashLoadMsgFalse" class="flashLoadMsg" target="_blank">安装或者启用FLASH播放器</a>
    <div :class=" drawPanel ? 'livePlayer':'drawPanel' ">
      <div style="width: 100%; height: 100%;" id="livePlayer"></div>
    </div>
    <div :class=" !drawPanel ? 'livePlayer':'drawPanel' ">
      <div style="width: 100%; height: 100%;" id="drawPanel"></div>
    </div>
    <div v-if="allow_speak_interaction === 'true'" @click="starLive" class="starLive">
      <img src="./lm.png" width="30" alt="">
      <span>{{starLiveTxt}}</span>
    </div>
    <div v-if="liveNo_star" class="liveNo_star">
      <div class="t">
        <p>直播开始时间{{start_time}}</p>
        <p>请等待直播开始</p>
      </div>
    </div>
    <div id="audioInteractions"></div>
    <video id="interactionLocalVideo" style="height: 100%; width: 100%;" autoplay></video>
  </div>
</template>

<script>
  export default {
    data () {
      return {
        id: '',
        timer: null,
        flashLoadMsgFalse: false,
        starLiveTxt: '语音互动',
        allow_speak_interaction: false,
        start_time: '', // 直播开始时间
        liveNo_star: false, // 直播未开始
        drawPanel: true, // 显示视频模块和显示文档模块
        DWLive: null
      }
    },
    created () {
      this.id = this.$parent.info.id
      this.timer = setInterval(res => {
        this.htmlTime++
      }, 1000)
      // this.IsFlash()
      if (this.$parent.info.start_time) { // 直播是否开启
        this.liveNo_star = true
        this.start_time = this.$parent.info.start_time
      } else {
        this.liveNo_star = false
      }

      DWLive.init({
        userid: this.$parent.info.live.userid,
        roomid: this.$parent.info.live.roomid,
        groupid: '',
        viewername: this.$parent.info.live.viewername,
        viewertoken: this.$parent.info.live.viewertoken,
        viewercustomua: 'web',
        language: '',
        viewercustominfo: '{"exportInfos": [ {"key": "城市", "value": "北京"}, {"key": "姓名", "value": "哈哈"}]}',
        fastMode: true,
        pcH5Live: true,
        forceNew: false
      })
      const that = this
      DWLive.onLoginSuccess = function (data) {
        if (data.live.liveDuration === '-1') { // 直播结束
          that.drawPanel = true
        }
      }
      DWLive.onRoomSetting = function (data) { // 判断教师是否开启语音
        //console.log( data )
        that.allow_speak_interaction = data.allow_speak_interaction
      }
      DWLive.onSwitchVideoDoc = function (data) { // 判断视频为主还是直播为主
        // console.log(data)
        if (data === 'true') { // 视频为主
          that.drawPanel = true
        } else {
          that.drawPanel = false
        }
      }
    },
    mounted () {
      const that = this
      that.DWLive = DWLive
      window.on_cc_live_interaction_accept = function (data) { // 通话中
        that.starLiveTxt = '通话中'
      }
      window.on_cc_live_interaction_remote_media = function (p, chatuser, stream) {
        console.log(p)
        console.log(chatuser)
        console.log(stream)
        if (p.video) {
          $('#livePlayer').replaceWith('<div id="livePlayer"></div>')

          $('#videoInteractions').css('height', '100%')

          var id = 'interactionRemoteVideo' + chatuser.id
          $('#videoInteractions').append('<video id="' + id + '" style="height: 100%; width: 100%;" autoplay></video>')
          $('#' + id)[0].srcObject = stream
          $('#videoInteraction').hide()
        } else { // 远程音频
          var id = 'interactionRemoteAudio' + chatuser.id
          $('#audioInteractions').append('<audio id="' + id + '" autoplay controls></audio>')
          $('#' + id)[0].srcObject = stream
        }
      }
      window.on_cc_live_interaction_disconnect = function (data) { // 讲师关闭互动
        // console.log(data)
        that.starLiveTxt = '语音挂断'
      }
    },
    methods: {

      IsFlash () { // 判断是否启动Falsh
        var flag = false
        if (window.ActiveXObject) {
          try {
            let swf = new ActiveXObject('ShockwaveFlash.ShockwaveFlash')
            if (swf) {
              flag = true
            }
          } catch (e) {
          }
        } else {
          try {
            let swf = navigator.plugins['Shockwave Flash']
            if (swf) {
              flag = true
            }
          } catch (e) {
          }
        }
        // if (flag) { // true 启动
        //   this.flashLoadMsgFalse = false
        // } else {
        //   this.flashLoadMsgFalse = true
        // }
      },
      starLive () {
        const that = this
        if (this.starLiveTxt === '通话中') {
          DWLive.hangupInteraction()
        } else {
          DWLive.requestInteraction({
            video: false,
            audio: true
          })
          this.starLiveTxt = '语音链接中'
        }
      }
    },
    destroyed () {
      this.DWLive.hangupInteraction()
      this.$http.post('/apipx/Lesson/studyrecord', {
        lesson_id: this.id,
        time_lenght: this.htmlTime,
        num: 0,
        token: JSON.parse(localStorage.getItem('login')).token
      }).then(res => {
        clearInterval(this.timer)
      })
    }
  }
</script>

<style type="text/scss" lang="scss">
  .live {
    width: 100%;
    height: 100%;
    position: relative;

    .liveNo_star {
      width: 100%;
      height: 100%;
      position: absolute;
      left: 0;
      top: 0;
      background-color: #000;
      z-index: 9999;
      font-size: 18px;
      color: #fff;
      text-align: center;
      line-height: 40px;

      .t {
        height: 80px;
        position: absolute;
        top: 50%;
        margin-top: -40px;
        width: 100%;
        text-align: center;
      }

      p:last-child {
        font-size: 14px;
      }
    }

    .drawPanel {
      position: absolute;
      left: 20px;
      top: 20px;
      z-index: 100;
      width: 200px;
      height: 200px;
      box-shadow: 0px 0px 20px #c6c6c6;
      border-radius: 5px;
    }

    .livePlayer {
      position: absolute;
      left: 0;
      top: 0;
      z-index: 99;
      width: 100%;
      height: 100%;
    }

    .starLive {
      width: 100%;
      height: 30px;
      position: absolute;
      left: 0;
      bottom: 50px;
      z-index: 999999999;
      text-align: center;
      color: #ff8484;
    }

    .flashLoadMsg {
      color: #fff;
      text-align: center;
      position: absolute;
      left: 0;
      top: 20px;
      z-index: 999;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/videoLayer/live/live.vue